import { useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';
import { MessageSquare } from 'lucide-react';

function fmtTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  return sameDay
    ? d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString();
}

export default function MessagingConversations({ activeNumber, onSelect, refreshKey }) {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/voice/sms-conversations', { params: { limit: 100 } });
      setConversations(r.data?.conversations || []);
    } catch (err) {
      console.error('Failed to load conversations', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  if (loading) {
    return <div className="p-4 text-xs text-slate-400">Loading conversations...</div>;
  }

  if (!conversations.length) {
    return (
      <div className="p-6 text-center text-xs text-slate-400">
        <MessageSquare className="w-8 h-8 mx-auto mb-2 text-slate-300" />
        No conversations yet
      </div>
    );
  }

  return (
    <div className="divide-y divide-slate-100" data-testid="sms-conversations-list">
      {conversations.map((c) => {
        const active = activeNumber === c.number;
        const outbound = c.last_direction === 'outbound';
        const label = c.contact_name || c.number || '(no number)';
        return (
          <button
            key={c.number || Math.random()}
            data-testid={`sms-conv-${c.number}`}
            onClick={() => onSelect && onSelect({ number: c.number, contact_name: c.contact_name, contact_id: c.contact_id })}
            className={`w-full text-left px-4 py-3 hover:bg-slate-50 transition ${active ? 'bg-blue-50/60' : ''}`}
          >
            <div className="flex items-center justify-between gap-2">
              <p className="text-sm font-semibold text-slate-800 truncate">{label}</p>
              <span className="text-[10px] text-slate-400 flex-shrink-0">{fmtTime(c.last_at)}</span>
            </div>
            <div className="flex items-center gap-1 mt-0.5">
              {outbound && <span className="text-[10px] text-slate-400">You:</span>}
              <p className="text-xs text-slate-500 truncate flex-1">{c.last_body}</p>
            </div>
            {c.contact_name && c.number && (
              <p className="text-[10px] text-slate-400 mt-0.5">{c.number}</p>
            )}
          </button>
        );
      })}
    </div>
  );
}
